import React, { useRef, useState } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { Form, Breadcrumb, Row, Col, Button, Schema } from "rsuite";
import { createStructuredSelector } from "reselect";
import { SelectedDeviceSelector } from "../redux/selector";
import ArrowLeftLineIcon from "@rsuite/icons/ArrowLeftLine";
import { handleSendSms } from "../scripts/helper";

const Container = styled.div`
  width: 100%;
`;

const ChargSimComponent = ({ selectedDevice, handleBack }) => {
  const formRef = useRef();
  const [formValue, setFormValue] = useState({ code: "" });
  const model = Schema.Model({
    code: Schema.Types.StringType().isRequired("اجباری"),
  });

  const handleSubmit = () => {
    if (formRef.current.check()) {
      console.log("CHECK");
      var smsBody = formValue.code.split("#").join("%23");
      handleSendSms(smsBody, selectedDevice)
    } else {
      console.log("ERROR");
    }
  };

  return (
    <Container>
      <Breadcrumb separator={<ArrowLeftLineIcon />}>
        <Breadcrumb.Item
          style={{ color: "#f07d00" }}
          onClick={() => handleBack()}
        >
          تنظیمات
        </Breadcrumb.Item>
        <Breadcrumb.Item>شارژ سیمکارت</Breadcrumb.Item>
      </Breadcrumb>
      <Form
        autoComplete="off"
        ref={formRef}
        model={model}
        onChange={(val) => setFormValue(val)}
        formValue={formValue}
        fluid
      >
        <Form.Group>
          <Form.ControlLabel>
            کد دستوری و کد شارژ را وارد کنید
          </Form.ControlLabel>
          <Form.Control
            name="code"
            placeholder="#"
            style={{ direction: "ltr" }}
          />
        </Form.Group>
        <Row>
          <Col xs={12}>
            <Button
              size="sm"
              block
              appearance="primary"
              type="submit"
              color="orange"
              onClick={handleSubmit}
            >
              شارژ
            </Button>
          </Col>
          <Col xs={12}>
            <Button size="sm" block type="button" onClick={() => handleBack()}>
              لغو
            </Button>
          </Col>
        </Row>
      </Form>
    </Container>
  );
};

const mapStateToProps = createStructuredSelector({
  selectedDevice: SelectedDeviceSelector,
});

export default connect(mapStateToProps)(ChargSimComponent);
